/* eslint react/display-name:0 */
import React, { Component } from 'react';

export const NotificationStorageContext = React.createContext({});

export class NotificationStorageProvider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stack: [
                /* example
                 {
                    id: null,
                    type: '',
                    message: '',
                }, */
            ],
        };
    }

    addNotification = payload => {
        const { type = '', message = '' } = payload;

        const newNotificationId = this.state.stack.length
            ? this.state.stack[this.state.stack.length - 1].id + 1
            : 1;

        this.setState({
            stack: [
                ...this.state.stack,
                {
                    id: newNotificationId,
                    type,
                    message,
                },
            ],
        });
    };

    removeNotification = removeId => {
        this.setState({
            stack: this.state.stack.filter(err => err.id !== removeId),
        });
    };

    render() {
        return (
            <NotificationStorageContext.Provider
                value={{
                    notification: {
                        stack: this.state.stack,
                        addNotification: this.addNotification,
                        removeNotification: this.removeNotification,
                    },
                }}
            >
                {this.props.children}
            </NotificationStorageContext.Provider>
        );
    }
}

export const withNotificationStorageContext = BaseComponent => props => (
    <NotificationStorageContext.Consumer>
        {notification => <BaseComponent {...notification} {...props} />}
    </NotificationStorageContext.Consumer>
);
